import PureImage, { PureImageProps } from '../Image/PureImage';
import PureVideo, { PureVideoProps } from '../PureVideo/PureVideo';
import { Asset, Video } from '../model';
import { ImageScale } from '../Image/ImageScale';

type PureAssetProps = {
  asset?: Asset;
  video?: Video;
  imageProps?: Omit<PureImageProps, 'src' | 'width' | 'height'>;
  videoProps?: Omit<PureVideoProps, 'videoId'>;
  imageScale?: Partial<ImageScale>;
};

const PureAsset = ({ asset, video, imageProps, videoProps, imageScale }: PureAssetProps) => {
  if (video?.videoId) {
    return <PureVideo videoId={video.videoId} {...videoProps} />;
  }
  if (asset?.path) {
    return <PureImage src={asset.path} width={asset.width} height={asset.height} {...imageProps} scale={imageScale} />;
  }

  return null;
};

export default PureAsset;
